import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from './components';


@Injectable()
export class NotificationService {

  constructor(private snackBar: MatSnackBar) { }

  error(message: string, options?: any): void {
    // Usar setTimeout para evitar ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      // Configuración por defecto
      const config = {
        duration: 3000,
        data: { message },
        panelClass: ['mat-snackbar_error']
      };

      // Fusionar con las opciones proporcionadas
      if (options) {
        // Si se proporcionan panelClass, añadirlos a los existentes
        if (options.panelClass) {
          if (Array.isArray(options.panelClass)) {
            config.panelClass = [...config.panelClass, ...options.panelClass];
          } else {
            config.panelClass = [...config.panelClass, options.panelClass];
          }
          delete options.panelClass;
        }

        // Fusionar el resto de opciones
        Object.assign(config, options);
      }

      this.snackBar.openFromComponent(NotificationComponent, config);
    }, 0);
  }

  success(message: string, options?: any): void {
    // Usar setTimeout para evitar ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      // Configuración por defecto
      const config = {
        duration: 3000,
        data: { message },
        panelClass: ['mat-snackbar_success'],
        horizontalPosition: 'end' as const,
        verticalPosition: 'top' as const
      };

      // Fusionar con las opciones proporcionadas
      if (options) {
        // Si se proporcionan panelClass, añadirlos a los existentes
        if (options.panelClass) {
          if (Array.isArray(options.panelClass)) {
            config.panelClass = [...config.panelClass, ...options.panelClass];
          } else {
            config.panelClass = [...config.panelClass, options.panelClass];
          }
          delete options.panelClass;
        }

        // Fusionar el resto de opciones
        Object.assign(config, options);
      }

      this.snackBar.openFromComponent(NotificationComponent, config);
    }, 0);
  }

  /**
   * Muestra una notificación WebSocket usando Angular Material SnackBar (MÁS CONFIABLE)
   */
  showWebSocketNotification(notification: any): void {
    setTimeout(() => {
      // Determinar el estilo según el tipo de notificación
      let panelClass: string[] = ['websocket-notification'];
      let duration = 0; // No cerrar automáticamente
      let action = '✕'; // Botón de cerrar

      switch (notification.type?.toUpperCase()) {
        case 'BROADCAST':
          panelClass.push('websocket-broadcast');
          break;
        case 'ADMIN':
          panelClass.push('websocket-admin');
          break;
        case 'URGENT':
          panelClass.push('websocket-urgent');
          duration = 10000; // Cerrar después de 10 segundos para urgentes
          break;
        default:
          panelClass.push('websocket-general');
          break;
      }

      const title = notification.title || 'Nueva Notificación';
      const message = notification.message || notification.content || 'Has recibido una nueva notificación';
      const fullMessage = `${title}: ${message}`;

      // Mostrar SnackBar con botón de cerrar
      const snackBarRef = this.snackBar.open(fullMessage, action, {
        duration: duration,
        panelClass: panelClass,
        horizontalPosition: 'end',
        verticalPosition: 'top'
      });

      // Manejar el clic en el botón de cerrar
      snackBarRef.onAction().subscribe(() => {
        console.log('🔔 Notificación WebSocket cerrada por el usuario');
        snackBarRef.dismiss();
      });

      console.log('✅ Notificación WebSocket mostrada con SnackBar');
    }, 0);
  }

  info(message: string, options?: any): void {
    // Usar setTimeout para evitar ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      // Configuración por defecto
      const config = {
        duration: 5000,
        data: { message },
        panelClass: ['mat-snackbar_info']
      };

      // Fusionar con las opciones proporcionadas
      if (options) {
        // Si se proporcionan panelClass, añadirlos a los existentes
        if (options.panelClass) {
          if (Array.isArray(options.panelClass)) {
            config.panelClass = [...config.panelClass, ...options.panelClass];
          } else {
            config.panelClass = [...config.panelClass, options.panelClass];
          }
          delete options.panelClass;
        }

        // Fusionar el resto de opciones
        Object.assign(config, options);
      }

      this.snackBar.openFromComponent(NotificationComponent, config);
    }, 0);
  }


warning(message: string, options?: any): void {
  // Usar setTimeout para evitar ExpressionChangedAfterItHasBeenCheckedError
  setTimeout(() => {
    // Configuración por defecto
    const config = {
      duration: 4000,
      data: { message },
      panelClass: ['mat-snackbar_warning']
    };

    // Fusionar con las opciones proporcionadas
    if (options) {
      if (options.panelClass) {
        if (Array.isArray(options.panelClass)) {
          config.panelClass = [...config.panelClass, ...options.panelClass];
        } else {
          config.panelClass = [...config.panelClass, options.panelClass];
        }
        delete options.panelClass;
      }

      Object.assign(config, options);
    }

    this.snackBar.openFromComponent(NotificationComponent, config);
  }, 0);
}

}


